var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"senha-politicas"},_vm._l((_vm.value.filter(m => m.visivel)),function(regra,idx){return _c('div',{key:idx,staticClass:"regra",class:{ valida: regra.valida }},[(regra.valida)?_c('i',{staticClass:"icon-ic_check_green"}):_c('i',{staticClass:"icon-ic_close"}),_vm._v("\n    "+_vm._s(regra.mensagem)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }